// import { ConfigProvider } from 'antd';
// import 'antd/dist/antd.less';
// import React, { useEffect, useState, lazy } from 'react';
// import { Provider, useDispatch, useSelector } from 'react-redux';
// import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
// import SimpleReactLightbox from 'simple-react-lightbox';
// import { ThemeProvider } from 'styled-components';
// import ProtectedRoute from './components/utilities/protectedRoute';
// import config from './config/config';
// import store, { rrfProps } from './redux/store';
// import CustomSpinner from './container/ui-elements/spinner/CustomSpinner';
// import 'animate.css';
// import Admin from './routes/admin';
// import Person from './routes/employee';
// import Auth from './routes/auth';
// import './static/css/style.css';
// import { getItem } from './utility/localStorageControl';
// import { getMessage } from './redux/authentication/actionCreator';
// import { io } from 'socket.io-client'
// // import addNotification, { Notifications } from 'react-push-notification';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import AllowNotifications from './container/admin/AllowNotifications';

// const NotFound = lazy(() => import('./container/pages/404'));

// const { themeColor } = config;

// function ProviderConfig() {
//   const { rtl, isLoggedIn, topMenu, mainContent, auth, isLoading } = useSelector((state) => {
//     return {
//       rtl: state.ChangeLayoutMode.rtlData,
//       topMenu: state.ChangeLayoutMode.topMenu,
//       mainContent: state.ChangeLayoutMode.mode,
//       isLoggedIn: state.auth.login,
//       isLoading: state.auth.loading,
//       auth: state.auth,
//     };
//   });


//   const dispatch = useDispatch()
//   const [role, setRole] = useState("");

//   useEffect(() => {
//     const role = getItem('role')
//     setRole(role)
//   })

//   if (Notification.permission === "default") {
//     Notification.requestPermission();
//   }

//   const { msg, messageLoading } = useSelector((state) => {
//     return {
//       msg: state.msg.data,
//       messageLoading: state.msg.loading
//     };
//   })

//   useEffect(() => {
//     dispatch(getMessage())
//   }, [])

//   useEffect(() => {
//     const socket = io(process.env.REACT_APP_API_ENDPOINT, {
//       transports: ["websocket"],
//       reconnection: true,
//       reconnectionAttempts: 5,  // Limit reconnection attempts
//       reconnectionDelay: 5000,
//     });
//     const usermasterId = getItem('userId');
//     if (usermasterId && isLoggedIn) {
//       socket.emit('panel-login', { usermasterId });

//       socket.on('pushNotification', (data) => {
//         handleNotification(data);
//       });
//       socket?.on('connect', () => {
//         if (usermasterId) {
//           socket.emit('reconnect-panel', usermasterId);
//         }
//       });
//       return () => {
//         socket.off('pushNotification');
//       };
//     }
//   }, [isLoggedIn])

//   // const handleNotification = (data) => {
//   //   addNotification({
//   //     icon: 'https://tpjira.teleuniv.in/favicon-32x32.png',
//   //     title: data?.title,
//   //     message: data?.message,
//   //     theme: "darkblue",
//   //     duration: 5000,
//   //     native: true,
//   //     options: { requireInteraction: true },
//   //     silent: false,
//   //   });
//   // };

//   const handleNotification = (data) => {
//     const title = data?.title ? `${data.title}: ` : "";
//     const message = data?.message || "New notification";

//     toast.info(`${title}${message}`, {
//       autoClose: 5000,
//       pauseOnHover: true,
//       closeOnClick: true,
//     });
//   };


//   return (
//     <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
//       <ThemeProvider theme={{ ...themeColor, rtl, topMenu, mainContent }}>
//         {isLoading ? (
//           <div className="custom-loading-spin-with-text">
//             <CustomSpinner />
//             <p style={{ fontWeight: 'bold', color: '#073886' }}>
//               Logging in please wait...
//             </p>
//           </div>
//         ) : (
//           <SimpleReactLightbox>
//             <Router basename={''}>
//               {!isLoggedIn ? (
//                 <div>
//                   <div className='text-center' dangerouslySetInnerHTML={{ __html: msg }} />
//                   <Routes>
//                     <Route path="/*" element={<Auth />} />
//                   </Routes>
//                 </div>
//               ) : (
//                 isLoggedIn && role === 'ADMIN' ?
//                   Notification.permission === 'granted' ?
//                     <Routes>
//                       <Route path="/admin/*" element={<ProtectedRoute path="/*" Component={Admin} />} />
//                       <Route path="*" element={<NotFound />} />
//                     </Routes>
//                     :
//                     <AllowNotifications />
//                   :
//                   isLoggedIn && (role === 'EMPLOYEE' || role === 'INTERN') &&
//                     Notification.permission === 'granted' ?
//                     <Routes>
//                       <Route path="/employee/*" element={<ProtectedRoute path="/*" Component={Person} />} />
//                       <Route path="*" element={<NotFound />} />
//                     </Routes>
//                     :
//                     <AllowNotifications />
//               )
//               }
//               {isLoggedIn && role === 'ADMIN'
//                 && Notification.permission === 'granted'
//                 && (
//                   <Routes>
//                     <Route path="/" element={<Navigate to="/admin" />} />
//                   </Routes>
//                 )}
//               {isLoggedIn && (role === 'EMPLOYEE' || role === 'INTERN')
//                 && Notification.permission === 'granted'
//                 && (
//                   <Routes>
//                     <Route path="/" element={<Navigate to="/employee" />} />
//                   </Routes>
//                 )}
//             </Router>
//           </SimpleReactLightbox>
//         )}
//       </ThemeProvider>
//     </ConfigProvider>
//   );
// }

// function App() {


//   return (
//     <Provider store={store}>

//       <ProviderConfig />
//     </Provider>
//   );
// }

// export default App;


import { ConfigProvider } from 'antd';
import 'antd/dist/antd.less';
import React, { useEffect, useState, lazy } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import SimpleReactLightbox from 'simple-react-lightbox';
import { ThemeProvider } from 'styled-components';
import ProtectedRoute from './components/utilities/protectedRoute';
import config from './config/config';
import store from './redux/store';
import CustomSpinner from './container/ui-elements/spinner/CustomSpinner';
import 'animate.css';
import Admin from './routes/admin';
import Person from './routes/employee';
import Teamlead from './routes/teamlead'; 
import Auth from './routes/auth';
import './static/css/style.css';
import { getItem } from './utility/localStorageControl';
import { getMessage } from './redux/authentication/actionCreator';
import { io } from 'socket.io-client';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import teamlead from './routes/teamlead';

const NotFound = lazy(() => import('./container/pages/404'));

const { themeColor } = config;

function ProviderConfig() {
  const { rtl, isLoggedIn, topMenu, mainContent, auth, isLoading } = useSelector((state) => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      mainContent: state.ChangeLayoutMode.mode,
      isLoggedIn: state.auth.login,
      isLoading: state.auth.loading,
      auth: state.auth,
    };
  });

  const dispatch = useDispatch();
  const [role, setRole] = useState("");

  useEffect(() => {
    const roleLS = getItem('role');
    setRole(roleLS);
  }); // keeping your original behavior

  const { msg, messageLoading } = useSelector((state) => {
    return {
      msg: state.msg.data,
      messageLoading: state.msg.loading,
    };
  });

  useEffect(() => {
    dispatch(getMessage());
  }, []);

  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_ENDPOINT, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 5000,
    });

    const usermasterId = getItem('userId');
    if (usermasterId && isLoggedIn) {
      socket.emit('panel-login', { usermasterId });

      socket.on('pushNotification', (data) => {
        handleNotification(data);
      });

      socket?.on('connect', () => {
        if (usermasterId) {
          socket.emit('reconnect-panel', usermasterId);
        }
      });

      return () => {
        socket.off('pushNotification');
      };
    }
  }, [isLoggedIn]);

  const handleNotification = (data) => {
    const title = data?.title ? `${data.title}: ` : "";
    const message = data?.message || "New notification";

    toast.info(`${title}${message}`, {
      autoClose: 5000,
      pauseOnHover: true,
      closeOnClick: true,
    });
  };

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...themeColor, rtl, topMenu, mainContent }}>
        <ToastContainer />
        {isLoading ? (
          <div className="custom-loading-spin-with-text">
            <CustomSpinner />
            <p style={{ fontWeight: 'bold', color: '#073886' }}>
              Logging in please wait...
            </p>
          </div>
        ) : (
          <SimpleReactLightbox>
            <Router basename={''}>
              {!isLoggedIn ? (
                <div>
                  <div className='text-center' dangerouslySetInnerHTML={{ __html: msg }} />
                  <Routes>
                    <Route path="/*" element={<Auth />} />
                  </Routes>
                </div>
              ) : (
                isLoggedIn && role === 'ADMIN' ?
                  <Routes>
                    <Route path="/admin/*" element={<ProtectedRoute path="/*" Component={Admin} />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                  :
                  isLoggedIn && role === 'TEAMLEAD' ?
                    <Routes>
                      <Route path="/teamlead/*" element={<ProtectedRoute path="/*" Component={Teamlead} />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                    :
                    isLoggedIn && (role === 'EMPLOYEE' || role === 'INTERN') ?
                      <Routes>
                        <Route path="/employee/*" element={<ProtectedRoute path="/*" Component={Person} />} />
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                      :
                      null
              )}

              {isLoggedIn && role === 'ADMIN' && (
                <Routes>
                  <Route path="/" element={<Navigate to="/admin" />} />
                </Routes>
              )}

              {isLoggedIn && role === 'TEAMLEAD' && (
                <Routes>
                  <Route path="/" element={<Navigate to="/teamlead" />} />
                </Routes>
              )}

              {isLoggedIn && (role === 'EMPLOYEE' || role === 'INTERN') && (
                <Routes>
                  <Route path="/" element={<Navigate to="/employee" />} />
                </Routes>
              )}
            </Router>
          </SimpleReactLightbox>
        )}
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default App;
